import { messages } from "@/shared/i18n";

/**
 * Account-activation feature error code mappings.
 *
 * Maps backend RFC 7807 Problem Details error codes to localized messages.
 */
export const ACCOUNT_ACTIVATION_ERROR_CODES: Record<string, string> = {
  "AccountActivation.Check": messages.accountActivation.errors.invalidLink,
  "AccountActivation.Set": messages.accountActivation.errors.invalidLink,
  "ReCaptcha.InvalidToken": messages.accountActivation.errors.recaptchaFailed,
};
